import axios from "axios";

async function resolve(promise) {
  const resolved = {
    data: null,
    error: null,
  };
  try {
    resolved.data = await promise;
  } catch (e) {
    if (e.response && e.response.status && e.response.status === 401) {
      localStorage.removeItem("token");
      //Unauthorized entry redirect
      localStorage.removeItem("token")
      window.location = "/loginnew/signIn?redirect=" + window.location.pathname
    }
    resolved.error = e.response ? e.response.data : e;
  }

  return resolved;
}

export async function signup_Api(page, email, password, confirmpassword) {
  var data = {
    page: page,
    email: email,
    password: password,
    confirmpassword: confirmpassword
  };
  //   var data = { tex: tex, track: JSON.stringify(track) };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/signup/", data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function verifycode(page, email, code) {
  var data = {
    page: page,
    email: email,
    code: code
  };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/verify_code/", data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function login_Api(email, password) {
  var data = {
    email: email,
    password: password,
  };
  // console.log(window.global.server_url)
  //   var data = { tex: tex, track: JSON.stringify(track) };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/login/", data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function logout_Api() {
  return await resolve(
    axios
      .delete(window.global.server_url + "api/v2/logout/", {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function current_user_Api() {
  return await resolve(
    axios
      .get(window.global.server_url + "api/v2/get_current_user/", {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function create_project_Api(name, env) {
  var data = {
    name: name,
    env_id: env,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/project/", data, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_all_project_Api() {
  return await resolve(
    axios
      .get(window.global.server_url + "api/v2/project/", {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_one_project_Api(proj_id) {
  return await resolve(
    axios
      .get(`${window.global.server_url}api/v2/project/${proj_id}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function update_project_Api(proj_id, name, env) {
  var data = {
    name: name,
    env_id: env,
  };
  return await resolve(
    axios
      .put(`${window.global.server_url}api/v2/project/${proj_id}/`, data, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function delete_project_Api(proj_id) {
  return await resolve(
    axios
      .delete(`${window.global.server_url}api/v2/project/${proj_id}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function create_environment_Api(name) {
  var data = {
    name: name,
  };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/environment/", data, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_all_environment_Api() {
  return await resolve(
    axios
      .get(window.global.server_url + "api/v2/environment/", {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_one_environment_Api(env_id) {
  return await resolve(
    axios
      .get(`${window.global.server_url}api/v2/environment/${env_id}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function update_environment_Api(env_id, name) {
  var data = {
    name: name,
  };

  return await resolve(
    axios
      .put(`${window.global.server_url}api/v2/environment/${env_id}/`, data, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function delete_environment_Api(env_id) {
  return await resolve(
    axios
      .delete(`${window.global.server_url}api/v2/environment/${env_id}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function create_project_file_Api(proj_id, file) {
  const formData = new FormData();
  if (typeof file !== "string") {
    file.forEach(element => {
      formData.append('file', element)
    });
  } else {
    formData.append('name', file)
  }

  return await resolve(
    axios
      .post(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/`,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function get_all_project_file_Api(proj_id) {
  return await resolve(
    axios
      .get(`${window.global.server_url}api/v2/project/${proj_id}/upload/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getProjectFileApi(proj_id, file_id) {
  return await resolve(
    axios
      .get(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/${file_id}/`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}


export async function renameProjectFileApi(proj_id, file_id, name) {
  const data = {
    name: name
  }
  return await resolve(
    axios
      .put(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/${file_id}/`, data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function indexing_Project_File_Api(proj_id, file_id) {
  var data = {
    index_file: true
  }
  return await resolve(
    axios
      .put(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/${file_id}/`, data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function update_project_file_Api(proj_id, file_id, name, content) {
  var data = {
    name: name,
    content: content

  };
  return await resolve(
    axios
      .put(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/${file_id}/`,
        data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function delete_project_file_Api(proj_id, file_id) {
  return await resolve(
    axios
      .delete(
        `${window.global.server_url}api/v2/project/${proj_id}/upload/${file_id}/`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function create_environment_file_Api(env_id, file) {
  const formData = new FormData();
  file.forEach(element => {
    formData.append('file', element)
    console.log(formData);
  });
  return await resolve(
    axios
      .post(
        `${window.global.server_url}api/v2/environment/${env_id}/upload/`,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function get_all_environment_file_Api(env_id) {
  return await resolve(
    axios
      .get(`${window.global.server_url}api/v2/environment/${env_id}/upload/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function get_one_environment_file_Api(env_id, file_id) {
  return await resolve(
    axios
      .get(
        `${window.global.server_url}api/v2/environment/${env_id}/upload/${file_id}/`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function update_environment_file_Api(env_id, file_id, name) {
  var data = {
    name: name,
  };

  return await resolve(
    axios
      .put(
        `${window.global.server_url}api/v2/environment/${env_id}/upload/${file_id}/`,
        data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => res.data)
  );
}

export async function delete_environment_file_Api(env_id, file_id) {
  return await resolve(
    axios
      .delete(
        `${window.global.server_url}api/v2/environment/${env_id}/upload/${file_id}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: "Token " + localStorage.getItem("token"),
        },
      }).then((res) => res.data)
  );
}

export async function delete_environment_api(env_id) {
  return await resolve(
    axios.delete(`${window.global.server_url}api/v2/environment/${env_id}/`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  )
}
//MARK: CompileTexAPI
export async function compileTexApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/compile/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}



export async function compileProjectApi(proj_id) {
  return await resolve(
    axios.get(`${window.global.server_url}api/v2/project/${proj_id}/compile/`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      }
    }).then((res) => res.data)
  )
}

export async function compileTrackTexApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/compile_track/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getPdfFile(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/pdf/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getProofPdfFileApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/proof_pdf/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getWebPdfFileApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/web_pdf/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getPrintPdfFileApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/print_pdf/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getTrackPdfFileApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/track_pdf/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function compileXmlApi(projectId, fileId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/xml/${fileId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getLatestProjectPdf(projectId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/pdf`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getLatestProjectXML(projectId) {
  return await resolve(
    axios(`${window.global.server_url}api/v2/project/${projectId}/xml`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function adminLogin(username, password) {
  var data = {
    username: username,
    password: password,
  };
  // console.log(window.global.server_url)
  //   var data = { tex: tex, track: JSON.stringify(track) };
  return await resolve(
    axios
      .post(window.global.server_url + "api/v2/admin/login", data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function checkAdminLogin() {
  return await resolve(
    axios(`${window.global.server_url}api/v2/admin/checklogin`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getInternalToken() {
  return await resolve(
    axios(`${window.global.server_url}api/v2/admin/internal_token`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function uploadInternalProject(projectFile, client) {
  const formdata = new FormData();
  formdata.append("client", client);
  formdata.append("file", projectFile);
  var token = await getInternalToken();
  console.log(token)
  formdata.append("token", token.data.token);
  return await resolve(axios.post(`${window.global.server_url}api/v2/internal/create/project`, formdata, {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: "Token " + localStorage.getItem("token"),
    },
  }).then((res) => res.data))
}

export async function uploadProjectSource(projectFile, projectId) {
  const formdata = new FormData();
  formdata.append("project_uuid", projectId);
  formdata.append("files", projectFile);
  return await resolve(axios.post(`${window.global.server_url}api/v2/admin/upload_source`, formdata, {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: "Token " + localStorage.getItem("token"),
    },
  }).then((res) => res.data))
}
//MARK:Search project
export async function internalProjectSearch(searchTerm) {
  var data = {
    search: searchTerm
  };
  return await resolve(
    axios.post(`${window.global.server_url}api/v2/admin/internal_search`, data, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}



export async function downloadProject(proj_id) {
  console.log((proj_id));

  return await resolve(
    axios.post(`${window.global.server_url}api/v2/admin/project/${proj_id}/download`, {}, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}


export async function uploadTemplate(formData) {
  return await resolve(
    axios.post(`${window.global.server_url}api/v2/admin/add_template`, formData, {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => res.data)
  );
}

export async function getTemplatesByCategory(cat) {
  return await resolve(
    axios.get(`${window.global.server_url}api/v2/public_templates?category=${cat}`, {
      headers: {
        "content-type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      }
    }).then((res) => res.data)
  )
}